import { WIZARD_DATA_RECEIVED, WIZARD_DATA_UNLOADED } from './types';

export default function wizard(state = [], action = {}){
  switch (action.type) {
    case WIZARD_DATA_RECEIVED:
      return action.data
    case WIZARD_DATA_UNLOADED:
      return []
    default:
      return state;
  }
}
